import { Injectable, signal } from '@angular/core';

export interface LoginHeaderData {
  title?: string;
  subtitle?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LoginHeaderService {
  private data = signal<LoginHeaderData>({});

  set(update: LoginHeaderData) {
    this.data.set(update);
  }

  get() {
    return this.data
  }
}
